export default __webpack_public_path__ + "6f0abb185bbcfe39528028a16b51445a.png";